module.exports = __webpack_public_path__ + "static/media/pick-unsplash.faff2a40.svg";